import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Button } from 'semantic-ui-react';
import Image from '../../../atoms/Image';
import Event, { EVENT_ACTIONS, EVENT_CATEGORIES } from '../../../modules/analytics/components/Event';
import CloseIcon from '../assets/CloseIcon.png';
var MessageDisplayBanner = /*#__PURE__*/function (_React$Component) {
  _inherits(MessageDisplayBanner, _React$Component);
  var _super = _createSuper(MessageDisplayBanner);
  function MessageDisplayBanner() {
    _classCallCheck(this, MessageDisplayBanner);
    return _super.apply(this, arguments);
  }
  _createClass(MessageDisplayBanner, [{
    key: "getContainerStyle",
    value: function getContainerStyle() {
      var backgroundColor = this.props.backgroundColor;
      var containerStyle = {};
      if (backgroundColor) {
        containerStyle = _objectSpread(_objectSpread({}, containerStyle), {}, {
          backgroundColor: backgroundColor
        });
      }
      return containerStyle;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        subject = _this$props.subject,
        onClick = _this$props.onClick,
        onClose = _this$props.onClose,
        buttonText = _this$props.buttonText,
        disableButton = _this$props.disableButton;
      return /*#__PURE__*/React.createElement("div", {
        className: "fm-message-display-banner",
        style: this.getContainerStyle()
      }, /*#__PURE__*/React.createElement("div", null, subject, !disableButton && /*#__PURE__*/React.createElement(Event, {
        eventType: "click",
        event: {
          category: EVENT_CATEGORIES.ANNOUNCEMENT_EVENT_CATEGORY,
          action: EVENT_ACTIONS.ANNOUNCEMENT_SEE_MORE_ACTION
        }
      }, /*#__PURE__*/React.createElement(Button, {
        inverted: true,
        size: "tiny",
        onClick: onClick
      }, buttonText))), /*#__PURE__*/React.createElement(Button, {
        onClick: onClose,
        "aria-label": "Close"
      }, /*#__PURE__*/React.createElement(Image, {
        src: CloseIcon,
        fluid: true,
        altText: "Close Icon"
      })));
    }
  }]);
  return MessageDisplayBanner;
}(React.Component);
export { MessageDisplayBanner as default };
MessageDisplayBanner.defaultProps = {
  backgroundColor: '',
  buttonText: 'See More',
  disableButton: false
};